import ProductVariant from '../../../domains/ProductVariant'
import IShopifyCheckout from '../../../domains/shopify/ShopifyCheckout'
import { decodeShopifyIdFromGraphqlIdResponse } from '../../../utils/decodeShopifyIdFromGraphqlIdResponse'
import { isInNewCartExperiment } from '../hooks/new-cart-exp-helper'
import { getVariantIdFromEdge, getVarientId } from '../hooks/new-cart-helper'

export const isLineItemExist = (shopifyCheckout: IShopifyCheckout, selectedVariant: ProductVariant) => {
  const isNewCartExp = isInNewCartExperiment()
  if (isNewCartExp) {
    const lineItem = (shopifyCheckout.lineItems as any)?.find?.((item: any) => item.variantId === selectedVariant.id)
    const lineItemExist = !!lineItem
    return lineItemExist
  }
  const lineItems = shopifyCheckout.lineItems?.edges || []
  const selectedShopifyVarientId = getVarientId(selectedVariant)
  const selectedLineItemIndex = lineItems.findIndex(lineItem => {
    const varientId = decodeShopifyIdFromGraphqlIdResponse(getVariantIdFromEdge(lineItem))
    return varientId && Number(varientId) === Number(selectedShopifyVarientId)
  })
  const lineItemExist = selectedLineItemIndex > -1
  return lineItemExist
}
